import { useState } from "react";
import { TextInput } from "../../../../components/ui/inputs";
import localization from "../../../../config/localization";
import { Button } from "../../../../components/ui/Button";
import userService from "../../services/user.service";
import { toastService as toast } from "../../../../components/ui/toast/toast.service";
import { OtpModal } from "../../../../components/ui/modals";
import { useNavigate } from "react-router-dom";
import { changeLoginModalState } from "../../../../reducers/appStateReducer";
import { useAppDispatch } from "../../../../store/hooks";
import { Validations } from "../../../../models/constants/validations";

export function EmailVerification({ userId, handleBackButton }: { userId: string, handleBackButton: () => void }) {

    const [email, setEmail] = useState("");
    const [emailErrorMessage, setEmailErrorMessage] = useState<string | null>(null);
    const [emailVerificationErrorMessage, setEmailVerificationErrorMessage] = useState("");
    const [showEmailVerificationModal, setShowEmailVerificationModal] = useState(false);

    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const handleSendEmailVerificationCode = (userId: string) => {
        userService.sendEmailVerificationCode(userId, email).then((response) => {
            if (response.isSuccess) {
                var message = localization.getString(response.message);
                toast.success(message);
                setTimeout(() => {
                    setShowEmailVerificationModal(true);
                }, 1000);
            }
        });
    };

    const handleResendEmailVerificationCode = (userId: string) => {
        userService.sendEmailVerificationCode(userId, email).then((response) => {
            if (response.isSuccess) {
                var message = localization.getString(response.message);
                toast.success(message);
                setEmailVerificationErrorMessage("");
            }
        });
    };

    const handleVerifyEmailVerificationCode = (userId: string, otp: string) => {
        userService.verifyEmailVerificationCode(userId, otp).then((response) => {
            if (response.isSuccess) {
                var message = localization.getString(response.message);
                toast.success(message);
                setTimeout(() => {
                    setShowEmailVerificationModal(false);
                    navigate("/");
                    dispatch(changeLoginModalState(true));
                }, 1000);
            }
        });
    };

    const handleCloseEmailVerificationModal = () => {
        setShowEmailVerificationModal(false);
        setEmailVerificationErrorMessage("");
    };

    const handleVerifyEmail = () => {
        if (validateEmail()) {
            handleSendEmailVerificationCode(userId)
        }
    };

    const clearEmailErrorMessageOnFocus = () => {
        setEmailErrorMessage((prev) => (prev ? null : prev));
    };

    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setEmail(value);
        setEmailErrorMessage((prev) => (value ? null : prev));
    };

    const validateEmail = () => {
        setEmailErrorMessage(null);
        if (!email) {
            setEmailErrorMessage("email_error");
            return false;
        }

        if (!Validations.email.regex.test(email)) {
            setEmailErrorMessage("valid_email");
            return false;
        }

        return true;
    };

    return (
        <div>
            <TextInput
                label={localization.email}
                placeholder={localization.enter_email}
                value={email}
                isRequired={true}
                error={emailErrorMessage && localization.getString(emailErrorMessage)}
                iconText={!showEmailVerificationModal ? localization.verify_btn : ""}
                iconClassName="hover:underline hover:font-bold cursor-pointer"
                onButtonClick={handleVerifyEmail}
                inputClassName="px-4 py-2 h-12"
                onChange={handleEmailChange}
                onFocus={clearEmailErrorMessageOnFocus}
                maxLength={240}
            />
            <OtpModal
                open={showEmailVerificationModal}
                inline={true}
                onSubmit={(otp) => {
                    handleVerifyEmailVerificationCode(userId, otp);
                }}
                errorMessage={emailVerificationErrorMessage}
                onResend={() => handleResendEmailVerificationCode(userId)}
                onClose={handleCloseEmailVerificationModal}
            />

            <Button
                type="submit"
                className="mt-4 w-full py-4 rounded-md text-white bg-primary-gradient"
                onClick={handleBackButton}
            >
                <span className="tracking-wider" >{localization.back}</span>
            </Button>

        </div>

    );
}